import { FunctionComponent, useEffect, useState, useCallback } from 'react'
import useStyles from './styles'
import { capitalize } from '@/utils/fnUtils'
import { Text, getTheme } from '@conexasaude/conexa-hero'
import { DateTime } from 'luxon'
import { HeroWrapper } from '@/styles/rebranded/HeroWrapper'

const TimeZoneLuxon: FunctionComponent = () => {
  const { footer } = useStyles()
  const [parsedDate, setParsedData] = useState<string>()
  const theme = getTheme()

  const parseDate = useCallback((date: DateTime) => {
    const parsedDate = date.toFormat('dd/LL/yyyy, EEEE - HH:mm:ss')
    const timeZoneText = 'Brasil (UTC-3) - Horário de Brasília'
    return `${capitalize(parsedDate)} - ${timeZoneText}`
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      const dateTimeNow = DateTime.now().setZone('America/Sao_Paulo')

      const parseDateTimeNow = parseDate(dateTimeNow)
      setParsedData(parseDateTimeNow)
    }, 1000)

    return () => clearInterval(interval)
  }, [parseDate])

  return (
    <HeroWrapper>
      <div css={footer}>
        <Text
          renderAs="p"
          variant="microCopy"
          color={theme.colors.neutral[200]}
        >
          {parsedDate}
        </Text>
      </div>
    </HeroWrapper>
  )
}

export default TimeZoneLuxon
